/**
 * 常量管理工具類
 * 所有常量必須在此類中統一定義和管理
 */
export class ConstantUtil {
  // API 相關常量
  public static readonly API_BASE_URL = 'https://api.uuspa.com.tw'
  public static readonly API_USER_LOGIN = '/api/v1/auth/member/login'
  public static readonly API_USER_REGISTER = '/api/v1/auth/member/register/complete'
  public static readonly API_USER_REGISTER_START = '/api/v1/auth/member/register/start'
  public static readonly API_USER_SEND_SMS_VERIFICATION = '/api/v1/auth/member/register/send-sms'
  public static readonly API_USER_PROFILE = '/api/v1/member/profile'
  public static readonly API_USER_LOGOUT = '/api/v1/auth/user/logout'
  public static readonly API_USER_FORGOT_PASSWORD = '/api/v1/auth/member/forgot-password'
  public static readonly API_USER_RESET_PASSWORD = '/api/v1/auth/member/reset-password'
  public static readonly API_USER_CHANGE_PASSWORD = '/api/v1/member/change-password'
  public static readonly API_USER_DEACTIVATE = '/api/v1/member/deactivate'
  public static readonly API_REFRESH_TOKEN = '/api/v1/auth/member/refresh'

  public static readonly API_ORDERS = '/api/v1/member/orders'
  public static readonly API_GET_REGIONS = '/api/v1/regions/summary'
  public static readonly API_GET_DISTRICTS = '/api/v1/regions/city'

  // 產品相關
  public static readonly API_PRODUCTS = '/api/v1/member/products'
  public static readonly API_PRODUCT_CATEGORIES = '/api/v1/member/products/category/'
  public static readonly API_PRODUCT_BRANDS = '/api/v1/member/products/brand/'
  public static readonly API_PRODUCT_SLUG = '/api/v1/member/products/slug/'

  // 電子票匣
  public static readonly API_USER_TICKETS = '/api/v1/member/tickets'

  // 存儲鍵名常量
  public static readonly STORAGE_USER_TOKEN = 'userToken'
  public static readonly STORAGE_USER_REFRESH_TOKEN = 'userRefreshToken'
  public static readonly STORAGE_USER_INFO = 'userInfo'
  public static readonly STORAGE_LANGUAGE = 'language'
  public static readonly STORAGE_THEME = 'theme'
  
  // 配置參數常量
  public static readonly API_TIMEOUT = 30000
  public static readonly API_RETRY_COUNT = 3
  public static readonly PAGE_SIZE = 20
  public static readonly MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB
  
  // UI 常量
  public static readonly COLORS = {
    PRIMARY: '#5092AF',
    PRIMARY_DARK: '#2563EB',
    PRIMARY_LIGHT: '#60A5FA',
    SUCCESS: '#10B981',
    WARNING: '#F59E0B',
    ERROR: '#EF4444',
    INFO: '#3B82F6'
  }
  
  // 業務常量
  public static readonly USER_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    SUSPENDED: 'suspended'
  }
  
  public static readonly ORDER_STATUS = {
    PENDING: 'pending',
    CONFIRMED: 'confirmed',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled'
  }
  
  // 加密相關常量
  public static readonly AES_KEY = '7706618877066188'
  public static readonly AES_MODE = 'ECB'
  public static readonly AES_PADDING = 'Pkcs7'

  // 路由常量
  public static readonly ROUTE_COURSES = '/courses'

  // 首頁區塊顯示上限
  public static readonly HOME_MAX_FEATURED_SHOPS = 5
  public static readonly HOME_MAX_SPECIAL_PROJECTS = 3
}
